import AssociadoList from './list';

export default function AssociadoPage() {
  return <AssociadoList />;
}
